import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import Moment from 'react-moment';
import classNames from 'classnames';

import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';

import DeleteIcon from '@material-ui/icons/Delete';

import InvoiceItem from './InvoiceItem';
import ImportDialog from './ImportDialog';
import {
  helpDispatch,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';

import { startAddBidTask } from '../../../store/actions/bids';
import {
  startEditLineItem,
  startRemoveLineItem,
} from '../../../store/actions/invoices';
import {
  startSetImportTimeMaterials,
  resetImportTimeMaterials,
  startAddLineItems,
  startUpdateTimecards,
} from '../../../store/actions';

import { startEditBidEditorState } from '../../../store/actions/bidEditor';

const styles = theme => ({
  root: {

  },
  button: {
    margin: theme.spacing.unit,
  },
  elevate: {
    zIndex: theme.zIndex.tooltipAction,
    backgroundColor: '#fff',
  },
});

class InvoiceItems extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showItem: undefined,
      lineItem: undefined,
      showImportDialog: false,
    }
  }

  handleEditOpen = () => {
    this.setState({showItem: "edit"});
  };

  handleAddOpen = () => {
    helpDispatch(TooltipTypes.INVOICE_ADD_ITEM);
    this.setState({showItem: "add"});
  };

  handleAddPayment() {
    this.setState({showPayment: "add"});
  }

  handleEditPayment() {
    this.setState({showPayment: "edit"});
  }

  handleClose = () => {
    this.setState({
      showItem: undefined,
      lineItem: undefined,
    });
  };

  render() {
    const {
      classes,
      invoice,
      help,
      startRemoveLineItem,
      startSetImportTimeMaterials,
      resetImportTimeMaterials,
      startAddLineItems,
      startEditBidEditorState,
      startUpdateTimecards
    } = this.props;
    const { showImportDialog } = this.state;

    //TODO: remove hack to convert Map to Array
    const lineItems = [];
    invoice.lineItems.forEach((lineItem, id) => {
      lineItems.push(Object.assign({}, {id}, lineItem));
    });

    return(
      <div>
        <InvoiceItem
          invoice={invoice}
          showItem={this.state.showItem}
          lineItem={this.state.lineItem}
          handleClose={this.handleClose}
        />
        <ImportDialog
          invoice={invoice}
          open={showImportDialog}
          onClose={() => {
            startAddLineItems(invoice.id)
              .then(() => startUpdateTimecards())
              .then(() => {
                resetImportTimeMaterials();
                this.setState({ showImportDialog: false });
              });
          }}
        />
        <Table>
          <TableHead>
            <TableRow>
              {false && <TableCell className={classes.tableCell} padding="dense" variant="head">Date</TableCell>}
              <TableCell className={classes.tableCell} padding="dense" variant="head">Description</TableCell>
              <TableCell className={classes.tableCell} padding="dense" variant="head" numeric>Quantity</TableCell>
              <TableCell className={classes.tableCell} padding="dense" variant="head" numeric>Unit Price</TableCell>
              <TableCell className={classes.tableCell} padding="dense" variant="head" numeric>Total</TableCell>
              <TableCell padding="none" variant="head" numeric />
            </TableRow>
          </TableHead>
          <Tooltip type={TooltipTypes.INVOICE_IMPORTED_TIME} placement="top">
            <TableBody>
              {lineItems.length !== 0 &&
                lineItems.map((lineItem) => {
                  return (
                    <TableRow
                      hover
                      key={lineItem.id}
                      style={{cursor: 'pointer'}}
                      >
                      {false &&
                        <TableCell
                          padding="dense"
                          onClick={() => this.setState({showItem: "edit", lineItem: lineItem})}
                          >
                          <Moment format="MMM Do">{new Date()}</Moment>
                        </TableCell>
                      }

                      <TableCell
                        padding="dense"
                        variant="body"
                        onClick={() => this.setState({showItem: "edit", lineItem: lineItem})}
                        >
                          {lineItem.description}
                      </TableCell>
                      <TableCell
                        padding="dense"
                        variant="body"
                        numeric
                        onClick={() => this.setState({showItem: "edit", lineItem: lineItem})}
                        >
                        {lineItem.quantity}
                      </TableCell>
                      <TableCell
                        padding="dense"
                        variant="body"
                        numeric
                        onClick={() => this.setState({showItem: "edit", lineItem: lineItem})}
                        >
                          ${Number(lineItem.unitPrice).toFixed(2)}
                      </TableCell>
                      <TableCell
                        padding="dense"
                        variant="body"
                        numeric
                        onClick={() => this.setState({showItem: "edit", lineItem: lineItem})}
                        >
                          ${Number(lineItem.total).toFixed(2)}
                      </TableCell>
                      <TableCell padding="none" variant="body" numeric>
                        <Button
                          aria-label="delete"
                          size="small"
                          className={classes.deleteButton}
                          onClick={() => startRemoveLineItem(invoice.id, lineItem.id)}
                          style={{color: '#757de8'}}
                          >
                          <DeleteIcon />
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
              })}
            </TableBody>
          </Tooltip>
        </Table>
        <Tooltip type={TooltipTypes.INVOICE_ADD_ITEM} placement="top">
          <Button
            color="primary"
            className={classNames(classes.button, help.isCurrentStep(TooltipTypes.INVOICE_ADD_ITEM) && classes.elevate)}
            onFocus={() => startEditBidEditorState("iLineItemsAdd")}
            onClick={this.handleAddOpen}>
            Add Item
          </Button>
        </Tooltip>
        <Tooltip type={TooltipTypes.INVOICE_ADD_TIME_MATERIALS} placement="top">
          <Button
            color="primary"
            className={classes.button}
            onFocus={() => startEditBidEditorState("iLineItemsAddTAndM")}
            onClick={() => {
              startSetImportTimeMaterials(invoice)
                .then(() => this.setState({ showImportDialog: true }));
              helpDispatch();
            }}
          >
            Add Time & Materials
          </Button>
        </Tooltip>
      </div>
    );
  }
}


InvoiceItems.defaultProps = {
  invoice: {
    template: {}
  }
};

const mapStateToProps = (state) => {
  const invoice = state.invoicesState.find(invoice => invoice.id === state.adminState.invoice.id);

  return {
    invoice: invoice,
    help: state.help,
  }
};

const mapDispatchToProps = {
  startAddBidTask,
  startEditLineItem,
  startRemoveLineItem,
  startSetImportTimeMaterials,
  resetImportTimeMaterials,
  startAddLineItems,
  startEditBidEditorState,
  startUpdateTimecards,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(InvoiceItems);



// WEBPACK FOOTER //
// ./src/components/admin/Invoice/InvoiceItems.jsx